
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { RootState, scrollTop } from '@share/utils';
import { ContactUsForm } from '../contact-us-form';
import { ContactUsHeading } from '../contact-us-heading';
import { ContactUsChat } from '../contact-us-chat';

import './style.scss';

export function ContactUsWrapper() {
  const loginStore = useSelector((state: RootState) => state.loginStore);
  const menuStore = useSelector((state: RootState) => state.navigationMenuStore);

  const { account } = loginStore;
  const { items, loading } = menuStore;

  const isRSITemplate = account?.isRSITemplate;
  const displayRsiClubChatEnabled = account?.displayRsiClubChatEnabled;
  const displayRsiClubChatRsiSiteidList = account?.displayRsiClubChatRsiSiteidList;
  const displayRsiClubChatRsiOrgidList = account?.displayRsiClubChatRsiOrgidList;
  
  const isRsiClub = useMemo(() => isRSITemplate && 
    displayRsiClubChatEnabled && 
    (
      displayRsiClubChatRsiOrgidList?.includes(items?.organizationId?.toString() as string) ||
      displayRsiClubChatRsiSiteidList?.includes(items?.siteId?.toString() as string)), [isRSITemplate, displayRsiClubChatEnabled, displayRsiClubChatRsiOrgidList, displayRsiClubChatRsiSiteidList, items]);

  const initializeZendesk = () => {
    try {
      // @ts-ignore
      return zE;
    } catch (error) {}
    return undefined;
  };

  const zEInstance = initializeZendesk();

  useEffect(() => {
    if (isRsiClub && zEInstance) {
      zEInstance('messenger', 'open');
    }
  }, [isRsiClub, zEInstance]);

  useEffect(() => {
    scrollTop();
  }, []);

  return (
    <>
      <ContactUsHeading />
      <ContactUsChat />
      <ContactUsForm isRsiClub={isRsiClub || loading} />
    </>
  );
}
